import { Box, Divider, Typography } from "@mui/material";
import React from "react";
import { IPageTitleBarProps } from "./PageTitleBar.types";

export const PageTitleBar: React.FC<IPageTitleBarProps> = (props) => {
  const { heading, rightHeading, sx } = props;
  const isNode = React.isValidElement(rightHeading);

  return (
    <Box sx={sx}>
      <Box
        className="page-title-bar-inner"
        display="flex"
        justifyContent={"space-between"}
        alignItems="flex-start"
      >
        {heading ? (
          <Typography variant="h2" fontWeight={"700"}>
            {heading}
          </Typography>
        ) : (
          <Box></Box>
        )}
        {isNode && <Box>{rightHeading}</Box>}
        {!isNode && (
          <Typography variant="body1" fontWeight={"400"}>
            {rightHeading}
          </Typography>
        )}
      </Box>
      {heading && <Divider sx={{ mt: 2, mb: 2 }} />}
    </Box>
  );
};
